import React, { useContext } from 'react'

import { ShopContext } from '../contexts/ShopContextProvider'
import { ShopContextType } from '../types'

export const useShop = <Currency extends string,ContentSource extends string>() => useContext( ShopContext ) as ShopContextType<ContentSource>